import React from 'react';
import { Text } from 'core/components';
import { secondsIntervalToText } from 'core/util/dateUtils';
import { getEvaluationPeriodSeconds, hasSubMinuteEvaluationPeriod } from 'app/stores/alerting/policyUtils';

interface EvaluationDisclosureProps {
  evaluationPeriod?: number | string | null;
}

const EvaluationDisclosure = ({ evaluationPeriod }: EvaluationDisclosureProps) =>
  hasSubMinuteEvaluationPeriod(evaluationPeriod) ? (
    <Text as="div" muted small>
      This graph may be inaccurate due to the policy&rsquo;s short evaluation frequency of{' '}
      {secondsIntervalToText(getEvaluationPeriodSeconds(evaluationPeriod))}.
    </Text>
  ) : null;

export default EvaluationDisclosure;
